import styled from 'styled-components';
import Colors from '../../../../styles/colors';

export const TableWrapper = styled.div`
  .table-wrapper {
    background: ${Colors.mainWhite};
    padding: 20px;
  }

  background-color: ${Colors.mainWhite};
  min-height: ${props => props.height || 750}px;
`;

export const TableContainer = styled.div`
  @media (max-width: 991px) {
    overflow-x: scroll;
  }
`;

export const Table = styled.table`
  th {
    font-size: 16px;
    color: ${Colors.fontGrey};
    vertical-align: middle;
    overflow-wrap: break-word;
  }
  th:last-child { width: 96px; }

  tbody {
    > tr {
      border-bottom: 1px solid ${Colors.lightBorder};

      > td {
        color: ${Colors.softBlack};
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: middle;
        overflow-wrap: break-word;
      }

      > td:last-child {
        width: 96px;
        > a {
          color: ${Colors.fontGrey};
        }
      }
    }
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.mainWhite};
  min-height: ${props => props.height || 750}px;
`;